import { ref, computed } from 'vue'
import { useUserStore } from '@/store/user'
import useTeamShare from '@teams/common/hooks/useTeamShare'

export type PageType =
  | 'bannedSpace' // 封禁 k.wps.cn/:groupId
  | 'notFoundSpace' // 空间不存在 k.wps.cn/:groupId
  | 'privateSpace' // 私密空间 k.wps.cn/:groupId
// | 'limitVisitorSpace' // 限制访客浏览空间 k.wps.cn/:groupId 这种情况不会走到Error页
export function useError() {
  const { settingInfo } = useTeamShare()
  const userStore = useUserStore()
  const loading = ref(true)

  const isLogin = computed(() => !!userStore.currentAccount?.userid)
  const groupAvatarVisible = computed(() => false)
  const pageType = computed<PageType>(() => {
    let type: PageType = 'notFoundSpace'
    if (settingInfo.value.private_group) {
      type = 'privateSpace'
    }
    // TODO: 封禁状态判断
    return type
  })
  return {
    pageType,
    loading,
    isLogin,
    groupAvatarVisible
  }
}
